module.exports = __webpack_public_path__ + "static/media/company5.7e8a9f02.png";